import { AGENT_CLI_CONFIG } from './agentCliConfig';

/** The daemon only ever stores the generic "Terminal" title: the UI's
 *  custom/agent name is never sent to it (CefBackend.create drops the title
 *  arg; there is no set_title IPC). A tab still carrying this default holds no
 *  user intent, so on reconnect we're free to replace it with a derived name. */
export function isGenericDaemonTitle(t: string | undefined): boolean {
  return !t || /^Terminal( \d+)?$/.test(t);
}

/** Re-derive an agent session's tab name from the ATELIER_AGENT stamp the
 *  daemon persists (surfaced as `agentType` by listSessions). This is what
 *  restores "Claude Code" after an app crash/reopen instead of a bare
 *  "Terminal" — the identity survives even though the title string doesn't. */
export function agentDisplayName(agentType: string | undefined): string | null {
  if (!agentType) return null;
  return AGENT_CLI_CONFIG[agentType]?.displayName ?? null;
}

/** Generate sequential title: "Name", "Name 2", "Name 3", ... against an
 *  existing set of sessions (any objects carrying a `title`). */
export function getNextTitle(baseName: string, sessions: { title: string }[]): string {
  const escaped = baseName.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  const pattern = new RegExp(`^${escaped}( \\d+)?$`);
  const matching = sessions.filter((s) => pattern.test(s.title));
  if (matching.length === 0) return baseName;
  let maxNum = 1; // the unnumbered one counts as 1
  for (const s of matching) {
    const m = s.title.match(/ (\d+)$/);
    if (m) maxNum = Math.max(maxNum, parseInt(m[1]));
  }
  return `${baseName} ${maxNum + 1}`;
}
